import { useState } from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink'

interface IRatingProps {
  rating: number
}

const STAR_STEP = 50
const STAR_CENTER_X = 22
const STAR_POINTS =
  '22,3 28.17,16.51 42.92,18.2 31.99,28.24 34.93,42.8 22,35.5 9.07,42.8 12.01,28.24 1.08,18.2 15.83,16.51'

let ratingInstances = 0

const Rating = ({ rating }: IRatingProps) => {
  // A grid holds many ratings and React 17 has no useId, so the clip path is numbered per mount --
  // sharing one id across products would put duplicate ids in the document.
  const [halfStarClipId] = useState(() => `samsclubHalfStar-${++ratingInstances}`)
  const decimal = Math.round((rating % 1) * 10) / 10
  const fullStars = Math.floor(rating)
  const finalFullStars = decimal >= 0.8 ? fullStars + 1 : fullStars
  const hasHalfStar = decimal >= 0.3 && decimal <= 0.7
  const total: number[] = Array.from(Array(5), () => 0)
  const fillColor = '#151f29'
  const emptyColor = '#dcdcdc'

  return (
    <EmptyLink color="#0a6cff">
      <svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 244 50" style={{ width: '92px', height: '19px' }}>
        {total.map((_, index) => (
          <g key={index} transform={`translate(${index * STAR_STEP}, 0)`}>
            <polygon fill={emptyColor} points={STAR_POINTS} />
            {index < finalFullStars && <polygon fill={fillColor} points={STAR_POINTS} />}
            {index === fullStars && hasHalfStar && (
              <clipPath id={halfStarClipId}>
                <rect x="0" y="0" width={STAR_CENTER_X} height="50" />
              </clipPath>
            )}
            {index === fullStars && hasHalfStar && (
              <polygon fill={fillColor} points={STAR_POINTS} clipPath={`url(#${halfStarClipId})`} />
            )}
          </g>
        ))}
      </svg>
    </EmptyLink>
  )
}

export default Rating
